import { render, staticRenderFns } from "./selectCus.vue?vue&type=template&id=bb0e3b28&scoped=true"
import script from "./selectCus.vue?vue&type=script&lang=js"
export * from "./selectCus.vue?vue&type=script&lang=js"
import style0 from "./selectCus.vue?vue&type=style&index=0&id=bb0e3b28&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0e3b28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb0e3b28')) {
      api.createRecord('bb0e3b28', component.options)
    } else {
      api.reload('bb0e3b28', component.options)
    }
    module.hot.accept("./selectCus.vue?vue&type=template&id=bb0e3b28&scoped=true", function () {
      api.rerender('bb0e3b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminalOrdering/contractManagement/form/components/selectCus.vue"
export default component.exports